import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { createContext, useContext } from 'react';

const FeatureFlagContext = createContext(null);
const useFeatureFlagContext = () => {
    const context = useContext(FeatureFlagContext);
    if (context === null) {
        throw new Error('useFeatureFlagContext must be used within a FeatureFlagProvider');
    }
    return context;
};
const FeatureFlagProvider = ({ children, features = [], }) => {
    return (jsxRuntimeExports.jsx(FeatureFlagContext.Provider, { value: features, children: children }));
};
const useFeatureFlag = ({ enabledFlag }) => {
    const availableFlags = useFeatureFlagContext();
    if (!availableFlags.length) {
        return false;
    }
    const flagsToCompare = Array.isArray(enabledFlag)
        ? enabledFlag
        : [enabledFlag];
    const filteredAgainstAvailableFlags = availableFlags.filter((availableFlag) => flagsToCompare.includes(availableFlag.name));
    const isFeatureActive = filteredAgainstAvailableFlags.length
        ? availableFlags.every((availableFlag) => availableFlag.enabled)
        : false;
    return isFeatureActive;
};
const FeatureFlag = ({ enabledFlag, children }) => {
    const isFeatureActive = useFeatureFlag({ enabledFlag });
    if (!isFeatureActive) {
        return null;
    }
    return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children });
};
FeatureFlagProvider.displayName = 'FeatureFlagProvider';
FeatureFlag.displayName = 'FeatureFlag';

export { FeatureFlag, FeatureFlagProvider, useFeatureFlag };
//# sourceMappingURL=FeatureFlag.js.map
